import styled from 'styled-components'

const MenuSubItemUi = styled.div`
  display: flex;
  gap: 5px;
  width: 100%;
`

export default MenuSubItemUi
